<div class="modal__warning d-flex align-items-center" *transloco="let convert;">
  <i class="allycon-warning text-warning icon-warning" aria-hidden="true"></i>
  <strong class="warning-text">{{ convert('vehicles.vehicleChangedWarning.textWarning') }}</strong>
</div>